import { IDateRange } from "../../../types/filter"
import {
  IGetSbCampaignsBody,
  SB_CAMPAIGNS_FILTER_TYPES,
  SB_CAMPAIGNS_STATE_FILTER,
} from "../types/sbCampaignApi.types"

interface IBuildSbCampaignsBody {
  dateRange: IDateRange
  isOrder: boolean
  isManaged: boolean
  stateFilter?: SB_CAMPAIGNS_STATE_FILTER
}

export function buildSbCampaignsBody({
  dateRange,
  isOrder,
  isManaged,
  stateFilter = SB_CAMPAIGNS_STATE_FILTER.ALL,
}: IBuildSbCampaignsBody): IGetSbCampaignsBody {
  return {
    fromDate: dateRange.from,
    toDate: dateRange.to,
    isManage: isManaged,
    filterType: isOrder ? SB_CAMPAIGNS_FILTER_TYPES.ORDERS : SB_CAMPAIGNS_FILTER_TYPES.DATE,
    stateFilter,
  }
}
